// @ts-check

export const ErrorConstants = {
    INVALID_PHONE_NUMBER: "ER_PHONE"
} 